import { useCallback, useEffect } from 'react'

export const useFormConfig = () => {
	// Makes sure that long labels fit (for input fields and non-extended dropdowns)
	const fitLongLabels = useCallback(() => {
		const labels = document.querySelectorAll('#main-form .control-label')
		labels.forEach((label) => {
			if (label instanceof HTMLLabelElement) {
				const parentDiv = label.parentElement
				const inputField = parentDiv?.querySelector(
					'input:not([type="radio"])',
				)

				if (!(inputField instanceof HTMLInputElement)) {
					return
				}

				// If the input hasn't got a value we first try fitting the label into one line by decreasing the font size (for inputs with values the label's font size is already small).
				const span = label.querySelector('span')
				if (span instanceof HTMLSpanElement) {
					if (inputField.value) {
						span.style.fontSize = '12px'
					} else {
						let fontSize = parseFloat(
							window.getComputedStyle(span).fontSize,
						)
						if (parentDiv) {
							while (
								span.getBoundingClientRect().width + 50 >
									parentDiv.getBoundingClientRect().width &&
								fontSize > 14
							) {
								span.style.fontSize = --fontSize + 'px'
								span.getBoundingClientRect()
							}
						}
					}
				}

				// If the labels still don't fit in the field we need to increase the hight of the field. For inputs with values, the field both contains the label and the value, whereas it's just the label for inputs without a value - therefore the calculations differ a bit
				let estNbrOfLines = inputField.value
					? Math.round((label.offsetHeight - 3) / 13)
					: Math.round(label.offsetHeight / 25)

				if (estNbrOfLines > 1) {
					inputField.style.height =
						(inputField.value
							? (estNbrOfLines + 2) * 15
							: (estNbrOfLines + 1) * 25) + 'px'
					if (inputField.value)
						inputField.style.paddingTop = estNbrOfLines * 15 + 'px'
				} else {
					inputField.style.height = '49px'
					if (inputField.value) inputField.style.paddingTop = '15px'
				}
			}
		})
	}, [])

	// Makes sure the selected value doesn't block the rest of the selectable values in an extended dropdown list (otherwise happens if the selected value takes up more than one line).
	const moveDropdownList = useCallback(() => {
		const expandedDropdownButton = document.querySelector(
			'#main-form button.form-control.dropdown-toggle[aria-expanded="true"]',
		)
		const dropdownList = expandedDropdownButton?.nextElementSibling
		if (
			!(
				expandedDropdownButton instanceof HTMLButtonElement &&
				dropdownList instanceof HTMLUListElement
			)
		)
			return

		const estNbrOfLines = Math.round(
			(expandedDropdownButton.offsetHeight - 20) / 25,
		)

		dropdownList.style.paddingTop =
			Math.max(25 * (estNbrOfLines - 1), 0) + 'px'
	}, [])

	useEffect(() => {
		const observer = new MutationObserver(() => {
			fitLongLabels()
			moveDropdownList()
		})
		observer.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['class', 'aria-expanded', 'value'],
		})

		requestAnimationFrame(fitLongLabels) // Run once when loaded
		requestAnimationFrame(moveDropdownList) // Run once when loaded

		window.addEventListener('resize', fitLongLabels)
		window.addEventListener('resize', moveDropdownList)

		return () => {
			observer.disconnect()
			window.removeEventListener('resize', fitLongLabels)
			window.removeEventListener('resize', moveDropdownList)
		}
	}, [fitLongLabels, moveDropdownList])
}
